import * as React from 'react';
import styled from 'styled-components';

import { ModalContent as CBModalContent } from '@creditornot/cbt-modal';

type Props = {
  children: React.ReactNode;
  /**
   * @default 'default'
   * use 'none' when the 24/16px padding is added by inner layout components like FormRow
   */
  padding?: 'default' | 'none';
  className?: string;
  style?: React.CSSProperties;
  dataTestId?: string;
};

// Note: CBModalContent provides e.g. dark scrollbars on dark mode
const StyledModalContent = styled(CBModalContent)`
  -webkit-overflow-scrolling: touch;
  flex: 1 1 auto;
  overscroll-behavior: contain;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const ModalContent = ({
  children,
  padding = 'default',
  className,
  style,
  dataTestId,
}: Props) => (
  <StyledModalContent
    tabIndex={-1}
    disablePadding={padding === 'none'}
    className={className}
    style={style}
    data-test-id={dataTestId}
  >
    {children}
  </StyledModalContent>
);
